import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import VideoPreview from 'modules/core/components/videoPreview';
import { inject, observer } from 'mobx-react';
import { EDIT_CATEGORY_TYPE, DELETE_CATEGORY_TYPE, CREATE_TUTORIAL_TYPE } from 'constants/adminPupups';
import ReactSlickSlider from 'react-slick';

@inject('categoryStore')
@inject('userStore')
@inject('editableCategoryStore')
@observer
export default class CategoryBlock extends React.Component {


  static propTypes = {
    title: PropTypes.string,
    video_amount: PropTypes.number,
    isAdmin: PropTypes.bool,
    type: PropTypes.object
  };

  static defaultProps = {
    title: '',
    video_amount: 0,
    isAdmin: false,
    type: null
  };

  getTutorials = () => {
    return this.props.categoryStore.getTutorialsById(this.props.itemId);
  };

  handleOpenEdit = e => {
    e.preventDefault();
    this.props.editableCategoryStore.activate(EDIT_CATEGORY_TYPE, this.props.itemId);
  };

  handleDelete = e => {
    e.preventDefault();
    this.props.editableCategoryStore.activate(DELETE_CATEGORY_TYPE, this.props.itemId);
  };

  HandleCategoryTitle = () => {
    const { title, isAdmin } = this.props;
    if (isAdmin) {
      return (
        <div className="category-head">
          <div className="title">
            <NavLink to={`/categories/?slug=${this.props.slug}`}
              className="video-amount">
              {title}
            </NavLink>
          </div>
          <div className="button-set">
            <button className="edit-category-btn ic ic-edit"
              onClick={this.handleOpenEdit}
              type="button" />

            <button className="ic ic-close-circle delete-category-btn modal"
              onClick={this.handleDelete}
              type="button" />
          </div>
        </div>
      )
    } else {
      return (
        <div className="category-head">
          <div className="title">
            <NavLink to={`/categories/?slug=${this.props.slug}`}
              className="video-amount">
              {title}
            </NavLink>
          </div>
        </div>
      )
    }
  };


  videoDurationTime = seconds => {
    let hours = parseInt(seconds / (60 * 60));
    let minutes = parseInt(((seconds - hours * 60 * 60) / 60));
    seconds = seconds - minutes * 60 - hours * 60 * 60;
    return `${hours}:${minutes}:${seconds}`
  };

  handleAddTutorial = () => {
    this.props.editableCategoryStore.activate(CREATE_TUTORIAL_TYPE, this.props.itemId);
  };

  render() {
    const sliderSettings = {
      dots: false,
      fade: false,
      arrows: false,
      infinite: false,
      accessibility: true,
      speed: 1200,
      slidesToShow: 3,
      slidesToScroll: 3,
      draggable: false,
      swipe: false,
      swipeToSlide: false,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          swipe: true,
          swipeToSlide: true
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          swipe: true,
          swipeToSlide: true
        }
      }
      ]
    };


    const videoItem = this.getTutorials().map((item, index) => {
      return (
        <div
          key={item.stubKey || index} className={this.props.singleMode && 'col col-12 col-md-4'}>
          <NavLink to={this.props.userStore.user ? `/tutorial/${item.slug}` : '/signIn'} >
            <VideoPreview
              placeholder={{ img: `https://prescriptionrevision.com${item.thumbnail_url}` }}
              title={item.title}
              categoryId={this.props.itemId}
              itemId={item.id}
              stubKey={item.stubKey}
              time={this.videoDurationTime(item.duration_time)}
              type={{ url: this.props.userStore.user ? `/tutorial/${item.slug}` : '/signIn' }}
              isAdmin={this.props.userStore.isAdmin()}
              viewed={item.viewed} />
          </NavLink>
        </div>
      )
    });


    const { video_amount } = this.props;
    //  const icon = this.handleIcon();
    const categoryHolder = this.HandleCategoryTitle();
    this.getTutorials();

    return (
      <div className="col">
        <div className="category-block">
          <div className="category-title-wrap">
            <div className="row">
              <div className="col">
                {categoryHolder}
                <div className="category-bottom">
                  <NavLink to={`/categories/?slug=${this.props.slug}`} className="video-amount">
                    <span className="ic ic-play" />
                    {video_amount} videos </NavLink>
                  {this.props.isAdmin &&
                    <button className="btn blue rounded add-tutorial-btn modal"
                      onClick={this.handleAddTutorial}
                      type="button">Add tutorial</button>}
                </div>
              </div>
            </div>
          </div>
          <div className={classNames('category-body', { row: this.props.singleMode })}>
            {this.props.singleMode ?
              videoItem :
              <ReactSlickSlider ref='slider' {...sliderSettings}>
                {videoItem}
              </ReactSlickSlider>
            }


          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/categories/components/CategoryBlock.js